import { useEffect } from "react";

/**
 * Compteur de visites : envoie chaque nouvelle visite à ton Google Apps Script,
 * qui ajoute 1 au total, note la visite dans ton Google Sheet et t'envoie le mail.
 * N'affiche rien sur la page. Ne nécessite ni base de données, ni dossier api/.
 *
 * - Une même personne est comptée au plus une fois toutes les 30 minutes.
 * - Pour ne pas compter tes propres visites : ouvre une fois ton site avec
 *   ?notrack à la fin de l'URL sur chacun de tes appareils. Pour annuler : ?track
 */

// Colle ici l'URL de ton déploiement Apps Script (elle se termine par /exec)
const GOOGLE_SCRIPT_URL = "https://script.google.com/macros/s/AKfycbyOEK6QStaPQmdsD7W_nMUO2UXg6eKhh1GkF5Ma_vhYuAg2A0LztHe4hUV2iR1TdNnE/exec";

const DEDUP_MINUTES = 30;
const LAST_VISIT_KEY = "portfolio-last-visit";
const IGNORE_KEY = "portfolio-ignore-visits";
const BOT_REGEX =
  /bot|crawl|spider|slurp|facebookexternalhit|whatsapp|telegram|discord|lighthouse|headless|preview/i;
const LOG = "[compteur]";

// Évite un double envoi si le composant est monté deux fois
let started = false;

function readStorage(key) {
  try {
    return window.localStorage.getItem(key);
  } catch {
    return null;
  }
}

function writeStorage(key, value) {
  try {
    if (value === null) window.localStorage.removeItem(key);
    else window.localStorage.setItem(key, value);
  } catch {
    // Stockage du navigateur indisponible : on continue sans
  }
}

export default function VisitTracker() {
  useEffect(() => {
    if (started) return;
    started = true;

    if (!GOOGLE_SCRIPT_URL.startsWith("https://script.google.com/")) {
      console.warn(LOG, "Colle l'URL de ton script Google dans VisitTracker.jsx.");
      return;
    }

    const { hostname, pathname, search } = window.location;
    if (hostname === "localhost" || hostname === "127.0.0.1") return; // pas de comptage en local

    const params = new URLSearchParams(search);
    if (params.has("notrack")) writeStorage(IGNORE_KEY, "1");
    if (params.has("track")) writeStorage(IGNORE_KEY, null);
    if (readStorage(IGNORE_KEY)) {
      console.info(LOG, "Tes visites sont ignorées sur ce navigateur (ajoute ?track à l'URL pour réactiver).");
      return;
    }

    if (navigator.webdriver || BOT_REGEX.test(navigator.userAgent)) return;

    const lastVisit = Number(readStorage(LAST_VISIT_KEY) || 0);
    if (Date.now() - lastVisit < DEDUP_MINUTES * 60 * 1000) {
      console.info(LOG, "Visite déjà comptée il y a moins de 30 minutes.");
      return;
    }

    let timezone = "";
    try {
      timezone = Intl.DateTimeFormat().resolvedOptions().timeZone || "";
    } catch {
      // Fuseau horaire indisponible
    }

    const visit = {
      page: pathname,
      referrer: document.referrer || "",
      device: /Mobi|Android|iPhone|iPad/i.test(navigator.userAgent) ? "Mobile" : "Ordinateur",
      language: navigator.language || "",
      timezone,
    };

    // "no-cors" + text/plain : le seul format qu'un script Google accepte directement depuis un site
    fetch(GOOGLE_SCRIPT_URL, {
      method: "POST",
      mode: "no-cors",
      headers: { "Content-Type": "text/plain;charset=utf-8" },
      body: JSON.stringify(visit),
    })
      .then(() => {
        writeStorage(LAST_VISIT_KEY, String(Date.now()));
        console.info(LOG, "Visite envoyée.");
      })
      .catch((err) => {
        console.warn(LOG, "Échec de l'envoi :", (err && err.message) || err);
      });
  }, []);

  return null;
}
